import Level from '@/classes/Level';
import store from '@/store/store';
class LevelCollection {
    levels = [];
    convertObjectsFromJson(levelJson) {
        const levelArray = [];
        levelJson.forEach((level) => {
            const tempLevel = new Level(level);
            levelArray.push(tempLevel);
        });
        levelArray.sort((a, b) => (window.dateHandler.convertToUTCTime(a.from) < window.dateHandler.convertToUTCTime(b.from)) ? -1 : 1);
        this.levels = levelArray;
    }
    getCurrentLevel() {
        return this.levels[this.levels.length - 1];
    }
    getLevelForFixedDate(date) {
        let returnValue = null;
        if (date === undefined || date === null) {
            date = store.getters.getSelectedDate;
        }
        if (this.levels.length === 1) {
            returnValue = this.levels[0];
        }
        else {
            for (const level of this.levels) {
                if (window.dateHandler.formatDateNoTime(date) >= window.dateHandler.formatDateNoTime(level.from)) {
                    returnValue = level;
                }
            }
        }
        return returnValue;
    }
}
export default LevelCollection;
